export default "__VITE_ASSET__62I7$_A6__"